import { put, all, takeLatest } from 'redux-saga/effects';
import { coresPrincipais, coresSecundarias, coresPlanoA } from '@utils';
import { alterarCorSistemaSuccess } from './actions';
import { ALTERA_COR_REQUEST } from './constants';

function* defineCorSistema({ values }) {
  switch (Number(values.plano)) {
    case 1:
      yield put(alterarCorSistemaSuccess(coresPrincipais));
      break;
    case 3:
      yield put(alterarCorSistemaSuccess(coresPlanoA));
      break;
    default:
      yield put(alterarCorSistemaSuccess(coresSecundarias));
  }
}

export default all([takeLatest(ALTERA_COR_REQUEST, defineCorSistema)]);
